<template>
    <div>
      <div 
                class="modal fade" 
                id="updateModal" 
                tabindex="-1" 
                aria-labelledby="policies-modal" 
                aria-hidden="true">
                  <div class="modal-dialog modal-xl">
                    <div class="modal-content rounded-0">
                      <div 
                      class="modal-header rounded-0" 
                      style="background-color:#169a5a;">
                        <h5 class="modaltitle text-uppercase" id="policies-modal">{{$t('modify.mod7')}}</h5>
                        <button  type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <b-row>
                          <b-col md="12">
                            <h3 class="tittleModal">{{$t('modify.mod7')}}</h3>
                            <hr>
                            <p>{{$t('modify.mod23')}}</p>
                            <br>
                            <button 
                                     
                                    @click="confirmUpdate"
                                    class="btn btn-success float-right" 
                                    type="button"
                                    style="border-radius:0px;">{{$t('modify.mod24')}}
                            </button>
                            <button 
                                    class="btn btn-secondary float-right mr-2" 
                                    style="border-radius:0px;" 
                                    data-dismiss="modal" 
                                    aria-label="Close">
                                    {{$t('modify.mod25')}}
                            </button>
                          </b-col>   
                          </b-row>
                      </div>
                    </div>
                  </div>
                </div>
                
                <alertModificada></alertModificada>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import alertModificada from '@/components/AlertReservaModificada'
    export default {
      components: {
        alertModificada,
      },
        methods: {
            ...mapActions('reservav2', ['actualizarReserva']),
            salir() {
                location.reload('/')
            },
            async confirmUpdate()
            {
                let resp = await this.actualizarReserva()
                
                if (resp == 'ok') {
                  await $('#updateModal').modal('toggle')
                  await $('#alertModificada').modal({
                      backdrop: 'static',
                      keyboard: false
                  })
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
.borderdiv{
  border-radius: 0px;
  border: solid 2px #b8b8b8;
}
.modaltitle{
    color: white;
}
hr{
  height: 5%;
}
.input-sucursal{
  border: none; 
  height: 60px; 
  padding-left: 15px; 
  padding-right: 15px; 
  font-size: 20px; 
  width: 99%;
  background: url("/img/flecha.png") no-repeat right/1.4% ;
  background-color: rgb(255, 255, 255);
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}
</style>